<template>
  <v-dialog v-model="dialogVisible" max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ heading }}</span>
        <div class="flex-grow-1"></div>
      </v-card-title>
      <v-card-text v-html="text"> </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="$emit('close')">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    //
  }),
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    heading: {
      default: "Alert!",
      required: false
    },
    text: {
      default: null,
      required: false
    }
  },
  watch: {
    //
  },
  methods: {
    //
  },
  computed: {
    //
  },
  mounted() {
    //
  }
};
</script>
